class TimeoutController {
    private controller: AbortController;
    private timeoutId: NodeJS.Timeout | null = null;
    private DEFAULT_TIMEOUT = 30000; //30초로 변경

    constructor() {
        this.controller = new AbortController();
    }

    // 요청을 위한 signal 가져오기
    get signal(): AbortSignal {
        return this.controller.signal;
    }

    // 타임아웃 시작
    startTimeout() {
        if (this.timeoutId === null) {
            this.timeoutId = setTimeout(() => this.controller.abort(), this.DEFAULT_TIMEOUT);
        }
    }

    // 타임아웃 해제
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    // 수동으로 요청 취소
    abort() {
        this.controller.abort();
        this.clearTimeout();
    }
}

export default TimeoutController;